<div id="news" class="mt-4">
  <div class="container">
    <div class="row">
      <div class="col-12" data-scroll>
        <h2 class="home-title text-center">NEWS <span class="first">&</span> EVENTS</h2>
      </div>
    </div>

    <div class="row mt-4" data-scroll>
      <owl-carousel-o [options]="customOptions">

        <ng-container *ngFor="let item of news">
          <ng-template carouselSlide [id]="item.title">
            <div class="card my-3">
              <div class="image">
                <a [href]="item.imgUrl" [attr.data-lightbox]="item.title">
                  <img [src]="item.imgUrl" [alt]="item.title" class="img-fluid">
                </a>
              </div>

              <div class="card-body">
                <svg width="100%" height="37" viewBox="0 0 400 37" fill="#fff"
                  xmlns="http://www.w3.org/2000/svg" class="rs_wev_shape">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M0 36.7249V0C4.80672 13.4937 32.3005 45.1819 186.978 25.6607C187.884 25.5464 188.853 25.4231 189.882 25.2921C211.794 22.5043 260.879 16.2594 308.275 19.1747C340.704 21.1694 399.834 36.6814 400 36.7249H0Z">
                  </path>
                </svg>

                <h4 class="title mt-5 mb-1">NEWS & EVENTS</h4>
                <p>{{ item.title }}</p>

              </div>
            </div>
          </ng-template>
        </ng-container>

      </owl-carousel-o>
    </div>
  </div>
</div>

<!-- <div id="career">
  <div class="row">
    <div class="col-12" data-scroll>
      <h2 class="home-title text-center"><span class="first">Career</span> Courses</h2>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-12">
      <a class="text-decoration-none" routerLink="/career-courses">
        <img src="/assets/img/career/1.jpeg" alt="Career" class="img-fluid w-100">
      </a>
    </div>
  </div>
</div> -->
